module.exports = __webpack_public_path__ + "public/images/science-background-pattern.605a83d7ffb438c128e5d05832831bcf.svg";